import { Injectable } from '@angular/core';
import { EnvConfigurationService } from '../envconf/envconf.service';
import { HttpClient } from '@angular/common/http';
import { PasswordResetResponseDto } from '../../models/auth/auth-dto';

@Injectable({
  providedIn: 'root'
})
export class PasswordResetService {
  endpoint = `${EnvConfigurationService.configuration.BACKEND_URL}${EnvConfigurationService.configuration.BACKEND_SUB_PATH}/passwordreset`;

  constructor(private readonly http: HttpClient) {}

  requestPasswordReset(username: string) {
    return this.http.post<Object>(`${this.endpoint}/request`, { username });
  }

  checkRequest(requestCode: string) {
    return this.http.get<PasswordResetResponseDto>(`${this.endpoint}/${requestCode}`);
  }

  changePassword(requestCode: string, password: string, confirmPassword: string) {
    return this.http.post<Object>(`${this.endpoint}/updatepassword/${requestCode}`, { password, confirmPassword });
  }
}
